import React, { useEffect, useState } from "react";
import {
  createNewSkillHelper,
  fetchAllCompanySuperSkillsHelper,
  findSkillByIdHelper,
  updateSkillHelper,
} from "helpers/backend_helper";
import { checkPermissionStatus } from "helpers/utils";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Select from "react-select";
import { toast } from "react-toastify";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

const EditSkill = ({ ...props }) => {
  const { t } = useTranslation();
  const [allSuperSkills, setAllSuperSkills] = useState([]);

  const { skillId } = useParams();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  const handleChangeFormData = (key, value) => {
    setFormData({
      ...(formData || {}),
      [key]: value,
    });
  };

  const fetchAllCompanySuperSkills = async (req, res) => {
    try {
      let payload = {
        notSkillId: skillId,
      };
      payload = encryptDataToArray(payload);

      let response = await fetchAllCompanySuperSkillsHelper({
        reqBody: {
          query: payload,
        },
      });

      let responseData = decryptDataFromArray(response);

      let superSkills = (responseData?.data?.superSkills || [])?.map(skill => ({
        ...skill,
        label: t(`Location_Manager.${skill?.name}`),
        value: skill?.id,
      }));

      setAllSuperSkills(superSkills);
    } catch (error) {
      toast.error(t(`Location_Manager.No super skills available`));
      setAllSuperSkills([]);
    }
  };

  const fetchSkillById = async (req, res) => {
    try {
      let response = await findSkillByIdHelper({
        skillId: skillId,
      });

      let responseData = decryptDataFromArray(response);

      let skill = responseData?.data?.skill;
      let skill_tag_id = {
        ...skill?.parent_skill_tag,
      };

      setFormData({
        ...skill,
        skill_tag_id: skill_tag_id,
      });
    } catch (error) {
      console.log(error);
      toast.error(t(`Location_Manager.Fetch skill failed`));
    }
  };

  const handleSaveSkill = async () => {
    try {
      let payload = {
        id: formData?.id,
        name: formData?.name,
        description: formData?.description,
        skill_tag_id: formData?.skill_tag_id?.id || null,
      };
      payload = encryptDataToArray(payload);

      let response = await updateSkillHelper({
        reqBody: {
          query: payload,
        },
      });

      toast.success(t(`Location_Manager.Skill updated`));
      setTimeout(() => {
        props?.history?.push("/skill-list");
      }, 1000);
    } catch (error) {
      toast.error(t(`Location_Manager.Update skill failed`));

      let errors = error?.response?.data?.errors || {};
      setErrors(errors);
    }
  };

  useEffect(() => {
    fetchSkillById();

    fetchAllCompanySuperSkills();

    return () => {};
  }, []);

  
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  
  if (!checkPermissionStatus("skill-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="page-content">
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/skill-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Location_Manager.Edit Skill`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-4">
            <Container fluid>
              <Row>
                <Col lg={12}>
                  <AvForm
                    className="outer-repeater"
                    onValidSubmit={e => {
                      e.preventDefault();

                      handleSaveSkill();
                    }}
                  >
                    <div data-repeater-list="outer-group" className="outer">
                      <div data-repeater-item className="outer">
                        <Row>
                          <Col lg={6}>
                            <FormGroup className="mb-2" row>
                              <Label htmlFor="name" className="col-form-label">
                                {t(`Location_Manager.Skill Name`)}
                                <span className="text-danger">*</span>
                              </Label>

                              <AvField
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                placeholder={t(`Location_Manager.Skill Name`)}
                                errorMessage="Skill Name Required."
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: t(
                                      `Location_Manager.Name required`
                                    ),
                                  },
                                  minLength: {
                                    value: 2,
                                    errorMessage: t(
                                      `Location_Manager.Name min length`
                                    ),
                                  },
                                }}
                                value={formData?.name || ""}
                                onChange={e => {
                                  let { name, value } = e?.target || {};
                                  handleChangeFormData(name, value);
                                }}
                                title={`${t(`Location_Manager.Skill Name`)}`}
                              />

                              <div className="error">{errors.name}</div>
                            </FormGroup>
                          </Col>

                          <Col lg="6">
                            <FormGroup className="mb-2" row>
                              <Label className="col-form-label">
                                {t(`Location_Manager.Super Skill any`)}
                              </Label>

                              <div
                                title={
                                  formData.skill_tag_id
                                    ? `${
                                        allSuperSkills.find(
                                          elem =>
                                            elem.value == formData.skill_tag_id
                                        )?.label
                                      }`
                                    : `${t(`Location_Manager.Super Skill any`)}`
                                }
                              >
                                <Select
                                  isClearable
                                  className="mb-3"
                                  placeholder={t(
                                    `Location_Manager.Select Super Skill any`
                                  )}
                                  id="skill_tag_id"
                                  name="skill_tag_id"
                                  options={allSuperSkills}
                                  value={{
                                    ...formData?.skill_tag_id,
                                    label: t(
                                      `Location_Manager.${formData?.skill_tag_id?.name}`
                                    ),
                                  }}
                                  onChange={e =>
                                    handleChangeFormData("skill_tag_id", e)
                                  }
                                  aria-label={t(
                                    `Location_Manager.Super Skill any`
                                  )} // Adds an ARIA label
                                  tabIndex="0"
                                />
                              </div>
                            </FormGroup>
                          </Col>

                          <Col lg={12}>
                            <FormGroup className="mb-2" row>
                              <Label
                                htmlFor="description"
                                className="col-form-label"
                              >
                                {t(`Location_Manager.Skill Description`)}
                              </Label>

                              <AvField
                                type="textarea"
                                className="form-control"
                                id="description"
                                name="description"
                                placeholder={t(
                                  `Location_Manager.Skill Description`
                                )}
                                value={formData?.description || ""}
                                onChange={e => {
                                  let { name, value } = e?.target || {};
                                  handleChangeFormData(name, value);
                                }}
                                title={`${t(
                                  `Location_Manager.Skill Description`
                                )}`}
                              />
                            </FormGroup>
                          </Col>

                          <div className="cta text-center gap-3 d-flex justify-content-start mt-4 mb-4">
                            <Link
                              className="btn btn-secondary"
                              to="/skill-list"
                            >
                              {t(`Location_Manager.Cancel`)}
                            </Link>
                            <Button
                              type="submit"
                              className="btn btn-primary"
                              color="success"
                            >
                              {t(`Location_Manager.Submit`)}
                            </Button>
                          </div>
                        </Row>
                      </div>
                    </div>
                  </AvForm>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSkill;
